export type AddLessonParams = { goalId: string } & Record<string, string | number>;

export enum EMPTY_STATE_ACTION {
    ADD_LESSON = 'add_lesson',
    ADD_SUBJECT = 'add_subject',
    ADD_TEAM = 'add_team',
    GO_TO_COURSE_CONTAINER = 'go_to_course_container',
}
